<template>
  <v-card
    tile
    flat
    color="grey lighten-5"
    v-if="loggedInUser != null && this.pagePermission == true"
  >
    <v-container>
      <v-alert v-if="successMessage != null" dense text type="success">
        {{ successMessage }}
      </v-alert>
      <v-alert v-if="errorMessage != null" dense outlined type="error">
        {{ errorMessage }}
      </v-alert>
      <DataTable
        sortby="name"
        :itemsperpage="1000"
        :items="users"
        :headers="headers"
        title="Team Members"
        itemtype="Team Member"
        :showdaterange="false"
        :loading="loading"
        :loadingtext="loadingText"
        @add-item="loadTeamMemberForm('Add')"
        @error="errorMessage = $event"
        @row-click="loadTeamMemberDashboard"
        @edit-row="loadTeamMemberForm('Edit', $event)"
      >
      </DataTable>
    </v-container>
    <v-dialog
      v-model="showTeamMemberDashboard"
      v-if="showTeamMemberDashboard == true"
      max-width="900px"
    >
      <Dashboard :userid="currentViewedTeamMember"></Dashboard>
    </v-dialog>
    <v-dialog
      v-model="showTeamMemberForm"
      v-if="showTeamMemberForm == true"
      max-width="800px"
    >
      <DialogForm
        :action="formAction"
        title="Team Member"
        :data="userData"
        @update-table="updateTable"
        @delete-item="loadTeamMemberForm('Delete', $event)"
        @success="successHandler"
        @close="showTeamMemberForm = false"
      ></DialogForm>
    </v-dialog>
  </v-card>
</template>

<script>
import DataTable from '@/components/DataTable/DataTable.vue'
import DialogForm from '@/components/DialogForm/DialogForm.vue'
import Dashboard from '@/components/Dashboard/Dashboard.vue'

export default {
  name: 'Team',
  components: { DataTable, DialogForm, Dashboard },
  formAction: null,
  data: () => ({
    pageName: 'Team',
    showTeamMemberForm: false,
    showTeamMemberDashboard: false,
    currentViewedTeamMember: null,
    loading: false,
    loadingText: null,
    formTitle: '',
    successMessage: null,
    errorMessage: null,
    dialogLoading: false,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    users: [],
    userData: {},
    headers: [
      {
        text: 'Name',
        align: 'left',
        value: 'name',
        sortable: true,
      },
      { text: 'User Type', value: 'type', sortable: true },
      { text: 'Email', value: 'email', sortable: false },
      { text: 'Phone Number', value: 'phone', sortable: false },
      { text: 'Actions', value: 'action', sortable: false },
    ],
  }),
  computed: {
    currentWeek() {
      return this.$store.getters.getCurrentWeek
    },
    userStoreData() {
      return this.$store.getters.getUsers
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    pagePermission() {
      let pagePermission = this.$store.getters.getPagePermission
      for (var i = 0; i < pagePermission.length; i++) {
        if (this.pageName == pagePermission[i]) {
          return true
        }
      }
      return false
    },
  },

  watch: {
    userStoreData() {
      this.users = []
      for (var userId of Object.keys(this.userStoreData)) {
        this.users.push(JSON.parse(JSON.stringify(this.userStoreData[userId])))
      }
    },
    showTeamMemberDashboard(val) {
      // eslint-disable-next-line no-console
      console.log(val)
      if (val == false) {
        this.getTeamMembers(this.currentWeek)
      }
    },
    loggedInUser(newVal, oldVal) {
      if (newVal != null && oldVal == null) {
        this.getTeamMembers()
      }
    },
  },

  methods: {
    successHandler(message) {
      var self = this
      self.successMessage = message
      self.showTeamMemberForm = false
      setTimeout(function() {
        self.successMessage = null
      }, 2000)
    },
    updateTable(event) {
      if (event.action == 'add' || event.action == 'edit') {
        if (event.action == 'add') {
          this.users.unshift(event.item)
        } else if (event.action == 'edit') {
          for (var index = 0; index < this.users.length; index++) {
            if (this.users[index].id == event.item.id) {
              this.users.splice(index, 1, event.item)
            }
          }
        }
      } else if (event.action == 'delete') {
        for (var i = 0; i < this.users.length; i++) {
          if (this.users[i].id == event.item) {
            this.users.splice(i, 1)
          }
        }
      }
    },
    loadTeamMemberDashboard(item) {
      this.currentViewedTeamMember = item.id
      this.showTeamMemberDashboard = true
    },
    loadTeamMemberForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.userData = JSON.parse(JSON.stringify(item))
      }
      this.showTeamMemberForm = true
    },
    resetErrors() {
      this.errorMessage = null
      this.successMessage = null
      this.dialogSuccessMessage = null
      this.dialogErrorMessage = null
    },
    getTeamMembers() {
      this.resetErrors()
      let self = this
      self.loadingText = 'Getting Team Members...'
      self.loading = true

      self.$store.dispatch('getTeamMembers').then(result => {
        if (result.success != true) {
          self.errorMessage = result.data.error.message
        }
        self.loading = false
      })
    },
  },
  mounted() {
    if (this.loggedInUser != null) {
      this.getTeamMembers()
    }
  },
}
</script>
